import { render, staticRenderFns } from "./ActualizacionVersionCliente.vue?vue&type=template&id=68663460&scoped=true"
import script from "./ActualizacionVersionCliente.vue?vue&type=script&lang=js"
export * from "./ActualizacionVersionCliente.vue?vue&type=script&lang=js"
import style0 from "./ActualizacionVersionCliente.vue?vue&type=style&index=0&id=68663460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68663460",
  null
  
)

export default component.exports